/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2021-12-31 11:05:42
 * @LastEditors: linxi
 * @LastEditTime: 2023-03-02 09:46:13
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Space, TableColumnType } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { ThemeData } from '../../theme/ThemeContext'
import { getAllList } from '../tenant/tenantSlice'

export interface AdreessType {
  value: string
  label: string
  children: []
}

export const columns = (
  onClick: (type: 'partner' | 'toggle', tenant: any) => void,
  startIndex: number,
  theme: ThemeData
): TableColumnType<any>[] => {
  const dispatch = useDispatch<RootDispatch>()

  const [provinceList, setProvinceList] = useState([])

  const [cityList, setCityList] = useState<any>([])

  const [countyList, setCountyList] = useState<any>([])

  useEffect(() => {
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setProvinceList(
          t.map((el: any) => ({ value: el.value, label: el.label }))
        )
        t.forEach((el: AdreessType) => {
          setCityList((v: any) => {
            return [...v, ...el.children]
          })
        })
        t.forEach((el: AdreessType) => {
          el.children.forEach((v: AdreessType) => {
            setCountyList((s: any) => {
              return [...s, ...v.children]
            })
          })
        })
      })
  }, [])
  const getNameForCode = (list: any[], code: string) => {
    let address = []
    address = list.filter((el: any) => {
      return el.value === code
    })
    return address[0]?.label
  }

  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构名称',
      key: 'tenantName',
      align: 'center',
      dataIndex: 'tenantName',
      width: '12rem',
      ellipsis: true,
    },
    {
      title: '合作平台',
      key: 'platformName',
      align: 'center',
      dataIndex: 'platformName',
      width: '12rem',
      ellipsis: true,
    },
    {
      title: '联系人',
      key: 'contactName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => t.contactName || '-',
    },
    {
      title: '联系电话',
      key: 'phone',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => t.phone || '-',
    },
    {
      title: '所属区域',
      key: 'createTime',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        let str = ''
        str += getNameForCode(provinceList, t.provinceCode)
        str += getNameForCode(cityList, t.cityCode)
        str += getNameForCode(countyList, t.countyCode)
        return str
      },
    },
    {
      title: '已绑定饮片厂',
      key: 'supplierName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => t.supplierName || '-',
    },
    {
      title: '代煎状态',
      key: 'openType',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function openType(_, t): ReactElement {
        const active = t.openType === 0
        return (
          <StateSwitch value={active} onChange={() => onClick('toggle', t)} />
        )
      },
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '10em',
      render: function ActionBar(_, t): ReactElement {
        return (
          <Button type='primary' onClick={() => onClick('partner', t)}>
            代煎管理
          </Button>
        )
      },
    },
  ]
}
